<script lang="ts">
  import { i18n } from "../../i18n.svelte";
  import Sprout from "../Sprout.svelte";

  const M = {
    ja: {
      name: "Tane チューター",
      status: "オンライン",
      u1: "現在完了って何？",
      a1: "現在完了（have + 過去分詞）は、過去の出来事が“今”とつながっていることを表します。",
      a2: "例：I have lived in Nagoya for three years.（＝今も住んでいる）",
      chips: ["例文をもっと", "過去形との違いは？"],
      input: "質問を入力…",
    },
    en: {
      name: "Tane Tutor",
      status: "online",
      u1: "What is the present perfect?",
      a1: "The present perfect (have + past participle) links a past event to “now.”",
      a2: "e.g. I have lived in Nagoya for three years. (= I still live here)",
      chips: ["More examples", "vs. past simple?"],
      input: "Type a question…",
    },
  } as const;
  const m = $derived(M[i18n.locale]);
</script>

<div class="scr">
  <div class="bar">
    <span class="ava"><Sprout size={20} stage={2} /></span>
    <div class="who">
      <strong>{m.name}</strong>
      <span><i></i>{m.status}</span>
    </div>
  </div>

  <div class="thread">
    <div class="msg user"><p>{m.u1}</p></div>
    <div class="msg bot">
      <span class="bava"><Sprout size={16} stage={2} /></span>
      <p>{m.a1}</p>
    </div>
    <div class="msg bot">
      <span class="bava" aria-hidden="true"></span>
      <p class="ex">{m.a2}</p>
    </div>
    <div class="typing">
      <span></span><span></span><span></span>
    </div>
  </div>

  <div class="chips">
    {#each m.chips as c}<button>{c}</button>{/each}
  </div>

  <div class="input">
    <span>{m.input}</span>
    <button class="send" aria-hidden="true">
      <svg viewBox="0 0 20 20" width="15" height="15"><path d="M3 10h12M10 4l6 6-6 6" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </button>
  </div>
</div>

<style>
  .scr {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 2.4rem 0.85rem 0.85rem;
    background: var(--paper-card);
    font-size: 12px;
    line-height: 1.55;
  }
  .bar {
    display: flex;
    align-items: center;
    gap: 0.55rem;
    padding-bottom: 0.7rem;
    border-bottom: 1px solid var(--line);
  }
  .ava {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: var(--sprout-soft);
    display: grid;
    place-items: center;
  }
  .who strong {
    display: block;
    font-size: 12.5px;
    color: var(--ink);
  }
  .who span {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 10px;
    color: var(--muted);
  }
  .who i {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: var(--sprout);
  }

  .thread {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.8rem 0;
    overflow: hidden;
  }
  .msg {
    display: flex;
    gap: 0.4rem;
    max-width: 88%;
  }
  .msg p {
    padding: 0.5rem 0.7rem;
    border-radius: 13px;
  }
  .msg.user {
    align-self: flex-end;
  }
  .msg.user p {
    background: var(--green);
    color: #fff;
    border-bottom-right-radius: 4px;
  }
  .msg.bot {
    align-self: flex-start;
  }
  .msg.bot p {
    background: var(--paper);
    border: 1px solid var(--line);
    color: var(--ink);
    border-bottom-left-radius: 4px;
  }
  .msg.bot p.ex {
    font-family: var(--font-mono);
    font-size: 10.5px;
    color: var(--ink-soft);
  }
  .bava {
    flex: none;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: var(--sprout-soft);
    display: grid;
    place-items: center;
  }
  .typing {
    display: inline-flex;
    gap: 3px;
    margin-left: 28px;
    padding: 0.45rem 0.6rem;
    background: var(--paper);
    border: 1px solid var(--line);
    border-radius: 13px;
    width: fit-content;
  }
  .typing span {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: var(--muted);
    animation: blink 1.2s infinite both;
  }
  .typing span:nth-child(2) {
    animation-delay: 0.2s;
  }
  .typing span:nth-child(3) {
    animation-delay: 0.4s;
  }
  @keyframes blink {
    0%, 60%, 100% {
      opacity: 0.25;
      transform: translateY(0);
    }
    30% {
      opacity: 1;
      transform: translateY(-2px);
    }
  }

  .chips {
    display: flex;
    gap: 0.4rem;
    padding-bottom: 0.6rem;
  }
  .chips button {
    font-size: 10.5px;
    color: var(--green-deep);
    border: 1px solid var(--sprout);
    background: rgba(95, 179, 100, 0.1);
    padding: 0.35em 0.7em;
    border-radius: 999px;
  }

  .input {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    background: var(--paper);
    border: 1px solid var(--line);
    border-radius: 999px;
    padding: 0.35rem 0.35rem 0.35rem 0.85rem;
    color: var(--muted);
    font-size: 11px;
  }
  .send {
    flex: none;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: var(--green);
    display: grid;
    place-items: center;
  }
</style>
